<script setup lang="ts">
import { AlertCircle, Ban, FileQuestion, Home, ServerCrash } from "lucide-vue-next";
import type { NuxtError } from "#app";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";

const props = defineProps({
  error: Object as () => NuxtError,
});

const errorDetails = computed(() => {
  const statusCode = Number(props.error?.statusCode || 500);
  switch (statusCode) {
    case 404:
      return {
        icon: FileQuestion,
        title: "404 - Page Not Found",
        description: "Oops! The page you're looking for seems to have vanished into thin air.",
        color: "text-yellow-500",
      };
    case 403:
      return {
        icon: Ban,
        title: "403 - Access Denied",
        description: "It looks like you don't have the secret handshake to enter this area.",
        color: "text-red-500",
      };
    default:
      return {
        icon: ServerCrash,
        title: "500 - Something Went Wrong",
        description: "Our servers are having a bit of a moment. We're working on it!",
        color: "text-destructive",
      };
  }
});

const handleError = () => clearError({ redirect: "/" });
</script>

<template>
  <main class="w-full h-screen">
    <NuxtLayout name="side-menu">
      <div class="flex items-center justify-center bg-background size-full p-4">
        <Card class="w-full max-w-md text-center shadow-lg border-2 border-border">
          <CardHeader>
            <div class="mx-auto p-4 bg-muted rounded-full w-fit">
              <component :is="errorDetails.icon" :class="errorDetails.color" class="w-16 h-16" />
            </div>
            <CardTitle class="text-3xl font-bold pt-4">{{ errorDetails.title }}</CardTitle>
            <CardDescription class="text-lg">{{ errorDetails.description }}</CardDescription>
          </CardHeader>

          <!-- <CardContent v-if="error?.message && error?.statusCode !== 404" class="bg-muted p-4 rounded-md">
        <div class="flex items-start space-x-3">
          <AlertCircle class="w-5 h-5 text-destructive" />
          <p class="text-sm text-left text-muted-foreground">
            <strong>Error Details:</strong> {{ error.message }}
          </p>
        </div>
      </CardContent> -->

          <CardContent v-if="error?.message && error?.statusCode !== 404">
            <Alert variant="destructive" class="text-left">
              <AlertCircle class="h-4 w-4" />
              <AlertTitle>Error Details</AlertTitle>
              <AlertDescription>{{ error.message }}</AlertDescription>
            </Alert>
          </CardContent>

          <!-- <CardFooter>
            <Button @click="handleError" class="w-full" variant="outline">
              <Home class="w-4 h-4 mr-2" />
              Go to Homepage
            </Button>
          </CardFooter> -->
        </Card>
      </div>
    </NuxtLayout>
  </main>
</template>
